import { render, staticRenderFns } from "./main.vue?vue&type=template&id=7e6e0b7c&scoped=true&"
import script from "./main.vue?vue&type=script&lang=ts&"
export * from "./main.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=7e6e0b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6e0b7c",
  null
  
)

export default component.exports